import React, { useState } from 'react';
import { ConfiguratorForm } from './ConfiguratorForm';
import { MatrixPreview } from './MatrixPreview';
import { CenterMarkSelector } from './CenterMarkSelector';
import { ColorSelector } from './ColorSelector';
import { SupportTypeSelector } from './SupportTypeSelector';
import { ActionButtons } from './ActionButtons';
export interface TextZone {
  id: string;
  text: string;
  radius: number;
  angle: number;
  isInverted: boolean;
  fontSize: number;
}
export interface MatrixData {
  textZones: TextZone[];
  centerMark: string;
  color: string;
  supportType: 'round' | 'square';
}
export function MatrixConfigurator() {
  const [matrixData, setMatrixData] = useState<MatrixData>({
    textZones: [{
      id: '1',
      text: '',
      radius: 140,
      angle: -90,
      isInverted: false,
      fontSize: 12
    }, {
      id: '2',
      text: '',
      radius: 140,
      angle: 90,
      isInverted: false,
      fontSize: 12
    }],
    centerMark: 'cross',
    color: '#E8927C',
    supportType: 'round'
  });
  const handleAddZone = () => {
    const newZone: TextZone = {
      id: Date.now().toString(),
      text: '',
      radius: 140,
      angle: 0,
      isInverted: false,
      fontSize: 12
    };
    setMatrixData(prevData => ({
      ...prevData,
      textZones: [...prevData.textZones, newZone]
    }));
  };
  const handleRemoveZone = (id: string) => {
    setMatrixData(prevData => ({
      ...prevData,
      textZones: prevData.textZones.filter(zone => zone.id !== id)
    }));
  };
  const handleZoneChange = (id: string, field: keyof TextZone, value: string | number) => {
    setMatrixData(prevData => ({
      ...prevData,
      textZones: prevData.textZones.map(zone => zone.id === id ? {
        ...zone,
        [field]: value
      } : zone)
    }));
  };
  const handleMarkChange = (mark: string) => {
    setMatrixData(prevData => ({
      ...prevData,
      centerMark: mark
    }));
  };
  const handleColorChange = (color: string) => {
    setMatrixData(prevData => ({
      ...prevData,
      color: color
    }));
  };
  const handleSupportTypeChange = (type: 'round' | 'square') => {
    setMatrixData(prevData => ({
      ...prevData,
      supportType: type
    }));
  };
  const resetForm = () => {
    setMatrixData({
      textZones: [{
        id: '1',
        text: '',
        radius: 140,
        angle: -90,
        isInverted: false,
        fontSize: 12
      }, {
        id: '2',
        text: '',
        radius: 140,
        angle: 90,
        isInverted: false,
        fontSize: 12
      }],
      centerMark: 'cross',
      color: '#E8927C',
      supportType: 'round'
    });
  };
  const saveMatrix = () => {
    const matrixSaveData = {
      text_zones: matrixData.textZones.map(zone => ({
        text: zone.text,
        radius: zone.radius,
        angle: zone.angle
      })),
      center_mark: matrixData.centerMark,
      color: matrixData.color,
      support_type: matrixData.supportType,
      date_created: new Date().toISOString()
    };
    console.log('Données de la matrice:', matrixSaveData);
    alert('Matrice sauvegardée!\n\nDonnées:\n' + JSON.stringify(matrixSaveData, null, 2));
  };
  return <div data-id="element-58">
      <div className="mb-12 grid grid-cols-1 gap-10 lg:grid-cols-2" data-id="element-59">
        <div className="space-y-6" data-id="element-60">
          <SupportTypeSelector selectedType={matrixData.supportType} onTypeChange={handleSupportTypeChange} data-id="element-61" />
          <ColorSelector selectedColor={matrixData.color} onColorChange={handleColorChange} data-id="element-62" />
          <ConfiguratorForm matrixData={matrixData} onAddZone={handleAddZone} onRemoveZone={handleRemoveZone} onZoneChange={handleZoneChange} data-id="element-63" />
        </div>
        <div className="space-y-6" data-id="element-64">
          <MatrixPreview matrixData={matrixData} data-id="element-65" />
          <CenterMarkSelector selectedMark={matrixData.centerMark} onMarkChange={handleMarkChange} data-id="element-66" />
        </div>
      </div>
      <ActionButtons onReset={resetForm} onSave={saveMatrix} data-id="element-67" />
    </div>;
}